<style lang="scss">
    .zican {
        min-height: 100%;
        height: auto !important;
        .sitebanner {
            background: url(../../assets/images/zican/banner.png) #092b76 no-repeat center;
            height: 187px;
            width: auto;
        }
        .siteconnect {
            width: auto;
            border-bottom: solid 1px #F0F0F0;
            text-align: center;
            padding: 10px 0;
        }
        .moudellogo {
            width: 120px;
            padding: 1px;
            display: block;
            margin-right: auto;
            margin-left: auto;
            .bg {
                width: 100%;
                height: 120px;
                text-align: center;
                display: inline-block;
                color: #FFF;
                margin-top: 60px;
                box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, .20);
                border-radius: 10px;
            }
            .bg:hover {
                box-shadow: 0 0 3px 3px rgba(157, 203, 255, .40);
            }
            .bg0 {
                background: url(../../assets/images/zican/exam_reg.png) no-repeat;
                background-position: center center;
            }
            .bg1 {
                background: url(../../assets/images/zican/exercise_test.png) no-repeat;
                background-position: center center;
            }
            .bg2 {
                background: url(../../assets/images/zican/print.png) no-repeat;
                background-position: center center;
            }
            .bg3 {
                background: url(../../assets/images/zican/grade.png) no-repeat;
                background-position: center center;
            }
            .bg4 {
                background: url(../../assets/images/zican/invoice.png) no-repeat;
                background-position: center center;
            }
            .bg5 {
                background: url(../../assets/images/zican/place.png) no-repeat;
                background-position: center center;
            }
            .bg6 {
                background: url(../../assets/images/zican/rule.png) no-repeat;
                background-position: center center;
            }
            .bg7 {
                background: url(../../assets/images/zican/work.png) no-repeat;
                background-position: center center;
            }
            .title {
                color: #333;
                margin-top: 15px;
                text-align: center;
                font-weight: 700;
                font-size: 15px;
            }
        }
        .ata-footer {
            position: fixed;
            bottom: 0;
            border-top: 1px solid #dddddd;
            padding: 7px 20px;
            text-align: center;
            font-size: 12px;
            color: #999999;
            background-color: white;
            width: 100%;
        }
    }
</style>
<template>
    <div class="zican">
        <div class="sitebanner"></div>
        <!--<div class="siteconnect "><a href="http://www.agents.org.cn/article/list-20140113224230.html"-->
        <!--target="_blank"><strong>试点城市考试机构</strong></a></div>-->
        <div class="container">
            <el-row>
                <el-col :span="8">
                    <router-link class="moudellogo" :to="{name:'default.examReg.chooseBatch'}">
                        <div class="bg0 bg"></div>
                        <div class="title">考试报名</div>
                    </router-link>
                </el-col>
                <el-col :span="8">
                    <div class="moudellogo">
                        <a class="moudellogo" href="https://eztest.org/tenant/12752/today/">
                            <div class="bg1 bg"></div>
                            <div class="title">机考练习</div>
                        </a>
                    </div>
                </el-col>
                <el-col :span="8">
                    <router-link class="moudellogo" :to="{name:'print'}">
                        <div class="bg2 bg"></div>
                        <div class="title">准考证打印</div>
                    </router-link>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <router-link class="moudellogo" :to="{name:'grade'}">
                        <div class="bg3 bg"></div>
                        <div class="title">成绩查询</div>
                    </router-link>
                </el-col>
                <el-col :span="8">
                    <div class="moudellogo">
                        <router-link class="moudellogo" :to="{name:'asset_invoiceTip'}">
                            <div class="bg4 bg"></div>
                            <div class="title">发票下载</div>
                        </router-link>
                    </div>
                </el-col>
                <!--<el-col :span="8">-->
                <!--<a class="moudellogo" target="_blank"-->
                <!--href="http://www.agents.org.cn/article/list-20140113224231.html">-->
                <!--<div class="bg5 bg"></div>-->
                <!--<div class="title">试点城市考试实施机构</div>-->
                <!--</a>-->
                <!--</el-col>-->
                <!--<el-col :span="8">-->
                <!--<a class="moudellogo" target="_blank"-->
                <!--href="http://www.agents.org.cn/article/list-20131211171502.html">-->
                <!--<div class="bg6 bg"></div>-->
                <!--<div class="title">相关规定</div>-->
                <!--</a>-->
                <!--</el-col>-->
                <el-col :span="8">
                    <div class="moudellogo">
                        <router-link class="moudellogo" :to="{name:'asset_download'}">
                        <div class="bg7 bg"></div>
                        <div class="title">相关材料下载</div>
                        </router-link>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="ata-footer">
            <div>考试服务平台技术专线：<span style="color:rgb(255,0,0);">021-61651876</span> (报名系统操作、缴费查询、准考证打印)</div>
            <div>Copyright ATA 1999-2019.ALL Rights Reserved</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default{
        data: function () {
            return {}
        },
        created: function () {
            let data = {domain: 'cas'};
            this.$store.commit('setCurrentExamInfo', data);
            this.getInfo('cas');
        },
        methods: {
            getInfo: function (domain) {
                this.$http.get(globalProvider.serviceUrl('ea/g/pcas/{domain}'), {
                    params: {
                        domain: domain
                    }
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        data.body.data.domain = domain;
                        this.$store.commit('setPageInfo', data.body.data);
                        if (data.body.data) {
                            if (data.body.data.online_chat) {
                                this.getkefu(data.body.data.online_chat);
                            }
                        }
                    }
                    else
                        this.$router.push({name: 'default.notFound'})
                })
            },
            getkefu: function (id) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = "http://live800.ata-test.net.cn:81/live800/chatClient/staticButton.js?companyID=228&configID=" + id + "&codeType=steady&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script);
                var script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.src = "http://live800.ata-test.net.cn:81/live800/chatClient/monitor.js?companyID=228&configID=1&codeType=custom&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script2);
                var script3 = document.createElement('script');
                script3.innerHTML = "function writehtml(){var temptext=StaticIcon_generate();document.getElementById('live81').innerHTML=temptext;setTimeout('write.src',9000);}setTimeout('writehtml()',1500);";
                document.getElementsByTagName("head")[0].appendChild(script3);
            },
        }
    }
</script>
